import React from 'react';
export const ProductShowcaseSection = () => {
  const items = [{
    name: 'Planificación por ciclos',
    desc: 'Inicio, desarrollo y cierre del proyecto para trabajar de 1.º a 7.º grado.',
    icon: '🎯',
    color: 'bg-blue-500/10 border-blue-500/30 text-blue-900'
  }, {
    name: 'Lengua y Ciencias Sociales',
    desc: 'Lectura, escritura, comprensión, países, mapas, banderas, culturas e investigación.',
    icon: '📖',
    color: 'bg-indigo-500/10 border-indigo-500/30 text-indigo-900'
  }, {
    name: 'Matemática y Estadística',
    desc: 'Operaciones, problemas, tablas de posiciones, gráficos, promedios, porcentajes y probabilidad.',
    icon: '📊',
    color: 'bg-purple-500/10 border-purple-500/30 text-purple-900'
  }, {
    name: 'Ciencias, Movimiento y Valores',
    desc: 'Alimentación, hidratación, cuidado corporal, Educación Física, trabajo en equipo y Fair Play.',
    icon: '🔬',
    color: 'bg-teal-500/10 border-teal-500/30 text-teal-900'
  }];
  return <section id="visualizacion" className="bg-white py-10 md:py-16 px-4 md:px-6" data-id="element-197">
      <span id="modulos" aria-hidden="true" className="block relative -top-20" data-id="element-198" />
      <div className="max-w-5xl mx-auto text-center" data-id="element-199">
        <h2 className="text-2xl md:text-4xl font-display font-extrabold mb-10 text-familia-bg max-w-3xl mx-auto leading-tight" data-id="element-200">
          Todo lo que necesitás en un solo sistema
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mb-6" data-id="element-201">
          {items.map((item, i) => <div key={i} className={`p-5 rounded-2xl border-2 ${item.color} flex flex-col items-center text-center transition-transform hover:-translate-y-1 cursor-default shadow-sm`} data-id="element-202">
              <span className="text-4xl mb-2" data-id="element-203">{item.icon}</span>
              <span className="text-base md:text-lg font-bold leading-tight mb-2" data-id="element-204">
                {item.name}
              </span>
              <span className="text-xs md:text-sm font-medium opacity-80 leading-relaxed" data-id="element-205">
                {item.desc}
              </span>
            </div>)}
        </div>

        <div className="bg-orange-500/10 border-2 border-orange-500/30 text-orange-900 p-5 rounded-2xl flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left max-w-3xl mx-auto shadow-sm" data-id="element-206">
          <span className="text-4xl" data-id="element-207">📝</span>
          <div data-id="element-208">
            <span className="text-base md:text-lg font-bold leading-tight mb-1 block" data-id="element-209">
              Evaluación integrada
            </span>
            <span className="text-xs md:text-sm font-medium opacity-80 leading-relaxed" data-id="element-210">
              Producciones, desafíos, trabajos grupales, autoevaluación y cierre
              del proceso.
            </span>
          </div>
        </div>
      </div>
    </section>;
};